import { EnvironmentModel, EnvName } from '@pt/models';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.dev.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvironmentModel = {
  shortName: 'aa',
  appName: 'PIN-UP Access Admin',
  appNameForTransaction: 'PIN-UP Global',
  production: false,
  useMocks: false,
  envName: EnvName.DEV,
  apiHost: (window as any).apiHost || 'https://dev-api-access.pin-up.team/api/v1/',
  wssHost: (window as any).wssHost || 'wss://api-pinup-team-dev.pin-up.team/api/v1/',
  lmsHost: (window as any).lmsHost || 'https://dev-trainee-lms.pin-up.team/',
  assetsHost: '',
  tokenPostfix: 'access-1',
  cookieDomain: 'pin-up.team',
  defaultLang: 'en',
  supportedUiLanguages: ['en', 'uk', 'ru'],
  theme: 'light',
  googleClientId: '472963368457-aav1nskummana9nirg16e7h6ntmf6kq3.apps.googleusercontent.com',
  slackTeamId: 'T01FZLAFN9Z',
  slackWorkspace: 'redcore-group',
  adminSlug: '',
  imagesOptimizationEnabled: false,
  jira: {
    baseUrl: 'https://jira.time2go.tech/',
    browseUrl: 'browse/',
    createIssueUrl: 'secure/CreateIssue!default.jspa?pid=11500',
    stafProject: 'projects/STAF/issues/STAF?filter=allissues',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
